export default __webpack_public_path__ + "static/media/390.eb49f0ee.png";